class VideoSlider {
  constructor(section) {
    this.section = section;

    this.swiperElement = this.section.querySelector(".js-ugc-video-swiper");
    this.modal = this.section.querySelector(".js-ugc-video-modal");

    this.modalVideo = this.section.querySelector(".ugc-video-modal__video");

    if (!this.swiperElement || !window.Swiper) return;

    this.init();
    this.bindModalEvents();
  }

  init() {
    this.swiper = new Swiper(this.swiperElement, {
      centeredSlides: false,
      loop: false,
      speed: 500,
      watchOverflow: true,
      watchSlidesProgress: true,
      preloadImages: false,
      lazyPreloadPrevNext: 1,
      observer: true,
      observeParents: true,

      slidesPerView: 1.2,
      spaceBetween: 16,

      navigation: {
        enabled: false,
        nextEl: this.section.querySelector(".ugc-video-slider__nav--next"),
        prevEl: this.section.querySelector(".ugc-video-slider__nav--prev"),
      },

      pagination: {
        el: this.section.querySelector(".ugc-video-slider__pagination"),
        clickable: true,
      },

      breakpoints: {
        1024: {
          slidesPerView: 3.7,
          spaceBetween: 20,
          initialSlide: 3,
          centeredSlides: true,
          navigation: {
            enabled: true,
          },
        },
      },

      on: {
        init: () => {
          setTimeout(() => {
            this.handleVideoPlayback();
          }, 100);
        },

        slideChangeTransitionEnd: () => {
          this.handleVideoPlayback();
        },
      },
    });
  }

  handleVideoPlayback() {
    const videos = this.section.querySelectorAll("video");

    videos.forEach((video) => {
      const slide = video.closest(".swiper-slide");

      if (!slide) return;

      if (slide.classList.contains("swiper-slide-visible")) {
        const source = video.querySelector("source");

        if (source?.dataset?.src && !source.src) {
          source.src = source.dataset.src;
          video.load();
        }

        const playVideo = () => {
          video.muted = true;

          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }
        };

        if (video.readyState >= 2) {
          playVideo();
        } else {
          video.addEventListener(
            "loadeddata",
            () => {
              playVideo();
            },
            { once: true },
          );
        }
      } else {
        video.pause();
      }
    });
  }

  bindModalEvents() {
    const cards = this.section.querySelectorAll(".ugc-video-card");

    cards.forEach((card) => {
      card.addEventListener("click", () => {
        const video = card.querySelector("video");
        const source = video?.querySelector("source");

        if (!source) return;

        this.modal.classList.add("is-active");

        document.body.classList.add("ugc-video-modal-open");

        this.modalVideo.src = source.src || source.dataset.src;

        this.modalVideo.load();

        const playPromise = this.modalVideo.play();

        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      });
    });

    const closeButtons = this.section.querySelectorAll(".js-ugc-video-close");

    closeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.closeModal();
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.modal.classList.remove("is-active");
    document.body.classList.remove("ugc-video-modal-open");
    this.modalVideo.pause();
    this.modalVideo.removeAttribute("src");
    this.modalVideo.load();
  }
}

document.querySelectorAll(".ugc-video-slider").forEach((section) => {
  new VideoSlider(section);
});